export function getSubjectAnswerCompletion(subject) {
    return subject?.attributes.totalQuestionCount > 0
        ? Math.floor((subject.attributes.answeredQuestionCount / subject.attributes.totalQuestionCount) * 100)
        : 0;
}
